/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyYenOff = createReactComponent("outline", "currency-yen-off", "IconCurrencyYenOff", [["path", { "d": "M12 19v-7m5 -7l-3.328 4.66", "key": "svg-0" }], ["path", { "d": "M8 17h8", "key": "svg-1" }], ["path", { "d": "M8 13h5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

export { IconCurrencyYenOff as default };
//# sourceMappingURL=IconCurrencyYenOff.mjs.map
